import { fetchProducts } from '../../api/api'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export type Category = {
  _id: string
  history: string
  cateName: string
  createdAt: string
  updatedAt: string
  __v: number
}

export type Product = {
  _id: string
  available: number
  rating: number
  name: string
  category: string
  description: string
  productImg: string
  price: number
  createdAt: string
  updatedAt: string
  __v: number
  cate: Category
}
export interface ProductState {
  success: boolean
  allProducts: Array<Product>
}

const fetchProductsAPI = createAsyncThunk(
  'product/fetchProducts',
  async () => {
    const response = fetchProducts()
    return ((await response).data)
  }
)
const initialState: ProductState = {
  success: false,
  allProducts: []
}
export const productSlices = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // getAllProducts: async () => {
    //   const data = await fetchProducts()
    // },

  },
  extraReducers: (builders) => {
    builders.addCase(fetchProductsAPI.fulfilled, (state, action) => {
      state.success = action.payload.success
      state.allProducts = action.payload.viewProduct
    })
  }
})

export { fetchProductsAPI }

export default productSlices.reducer
